/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Nolanguagesfound2Inputs */

const id_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada bahasa ditemukan`)
};

const ms_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada bahasa ditemui`)
};

const da_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen sprog fundet`)
};

const de_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Sprachen gefunden`)
};

const en_us2_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No languages found`)
};

const es_es2_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron idiomas`)
};

const es_mx2_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron idiomas`)
};

const fil_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang wika`)
};

const fr_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune langue trouvée`)
};

const it_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna lingua trovata`)
};

const hu_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs találat`)
};

const nl_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen talen gevonden`)
};

const no_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen språk funnet`)
};

const pl_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono języków`)
};

const pt_br2_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum idioma encontrado`)
};

const pt_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum idioma encontrado`)
};

const ro_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicio limbă găsită`)
};

const fi_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei kieliä löytynyt`)
};

const sv_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga språk hittades`)
};

const vi_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy ngôn ngữ`)
};

const tr_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dil bulunamadı`)
};

const cs_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenalezeny žádné jazyky`)
};

const bg_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени езици`)
};

const ru_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Языки не найдены`)
};

const uk_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мов не знайдено`)
};

const ar_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على لغات`)
};

const hi_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई भाषा नहीं मिली`)
};

const th_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบภาษา`)
};

const ja_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語が見つかりません`)
};

const zh_cn2_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到相关语言`)
};

const zh_hant1_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到相關語言`)
};

const ko_nav_nolanguagesfound2 = /** @type {(inputs: Nav_Nolanguagesfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언어를 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "No languages found" |
*
* @param {Nav_Nolanguagesfound2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_nolanguagesfound2 = /** @type {((inputs?: Nav_Nolanguagesfound2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Nolanguagesfound2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_nolanguagesfound2(inputs)
	if (locale === "ms") return ms_nav_nolanguagesfound2(inputs)
	if (locale === "da") return da_nav_nolanguagesfound2(inputs)
	if (locale === "de") return de_nav_nolanguagesfound2(inputs)
	if (locale === "en-US") return en_us2_nav_nolanguagesfound2(inputs)
	if (locale === "es-ES") return es_es2_nav_nolanguagesfound2(inputs)
	if (locale === "es-MX") return es_mx2_nav_nolanguagesfound2(inputs)
	if (locale === "fil") return fil_nav_nolanguagesfound2(inputs)
	if (locale === "fr") return fr_nav_nolanguagesfound2(inputs)
	if (locale === "it") return it_nav_nolanguagesfound2(inputs)
	if (locale === "hu") return hu_nav_nolanguagesfound2(inputs)
	if (locale === "nl") return nl_nav_nolanguagesfound2(inputs)
	if (locale === "no") return no_nav_nolanguagesfound2(inputs)
	if (locale === "pl") return pl_nav_nolanguagesfound2(inputs)
	if (locale === "pt-BR") return pt_br2_nav_nolanguagesfound2(inputs)
	if (locale === "pt") return pt_nav_nolanguagesfound2(inputs)
	if (locale === "ro") return ro_nav_nolanguagesfound2(inputs)
	if (locale === "fi") return fi_nav_nolanguagesfound2(inputs)
	if (locale === "sv") return sv_nav_nolanguagesfound2(inputs)
	if (locale === "vi") return vi_nav_nolanguagesfound2(inputs)
	if (locale === "tr") return tr_nav_nolanguagesfound2(inputs)
	if (locale === "cs") return cs_nav_nolanguagesfound2(inputs)
	if (locale === "bg") return bg_nav_nolanguagesfound2(inputs)
	if (locale === "ru") return ru_nav_nolanguagesfound2(inputs)
	if (locale === "uk") return uk_nav_nolanguagesfound2(inputs)
	if (locale === "ar") return ar_nav_nolanguagesfound2(inputs)
	if (locale === "hi") return hi_nav_nolanguagesfound2(inputs)
	if (locale === "th") return th_nav_nolanguagesfound2(inputs)
	if (locale === "ja") return ja_nav_nolanguagesfound2(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_nolanguagesfound2(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_nolanguagesfound2(inputs)
	return ko_nav_nolanguagesfound2(inputs)
});
export { nav_nolanguagesfound2 as "nav.noLanguagesFound" }